// Stats management with localStorage persistence

import { Stats } from '../types';

const STATS_KEY = 'v7p3r_labs_stats';

const defaultStats: Stats = {
  gamesPlayed: 0,
  wins: 0,
  losses: 0,
  draws: 0,
};

export const statsManager = {
  getStats(): Stats {
    try {
      const stored = localStorage.getItem(STATS_KEY);
      if (!stored) return { ...defaultStats };
      return JSON.parse(stored);
    } catch (error) {
      console.error('Error loading stats:', error);
      return { ...defaultStats };
    }
  },

  saveStats(stats: Stats): void {
    try {
      localStorage.setItem(STATS_KEY, JSON.stringify(stats));
    } catch (error) {
      console.error('Error saving stats:', error);
    }
  },

  recordGame(result: 'win' | 'loss' | 'draw'): void {
    const stats = this.getStats();
    stats.gamesPlayed += 1;

    if (result === 'win') stats.wins += 1;
    else if (result === 'loss') stats.losses += 1;
    else stats.draws += 1;

    this.saveStats(stats);
  },

  getWinRate(): number {
    const stats = this.getStats();
    if (stats.gamesPlayed === 0) return 0;
    return (stats.wins / stats.gamesPlayed) * 100;
  },

  reset(): void {
    this.saveStats({ ...defaultStats });
  },
};
